function elscr(value){
    var map = {'+':'1','ů':'1','ě':'2','ľ':'2','š':'3','č':'4','ř':'5','ť':'5','ž':'6','ý':'7','á':'8','í':'9','é':'0'};
    var output = '';
    var i = value.length;

    while(i--) {
      output = (map[value[i]] || value[i]) + output;
    }

    return output;
}